<template>
  <v-container grid-list-md fluid>
    <v-layout wrap>
      <v-flex v-for="course in courses" :key="course.id" xs12 md6 lg4 auto height="100%">
        <course-card :course="course" :mini="mini" class="mr-4" />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import CourseCard from "@/components/global/CourseCard";
export default {
  name: "CourseWidget",
  components: {
    CourseCard
  },
  props: {
    courses: {
      type: Array,
      default: null
    },
    mini: {
      type: Boolean,
      default: false
    }
  }
};
</script>
